import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import CourseItem from "../CourseItem/CourseItem";
import CourseEnhancements from "../CourseEnhancements/CourseEnhancements";
import { Box } from "@nib/layout";
import Heading from "@nib-components/heading";
import ExpanderGroup from "@nib-components/expander-group";
import ExpandedSection from "../ExpandedSection";
import useWindowDimensions from "../../utils/breakpoints";
import scrollToRef from "../../utils/scrollToRef";

const StyledHeading = styled(Heading)`
  text-align: left;
  margin-bottom: 1rem;
  ${breakpoint("md")`
    text-align: center;
  `}

  // TODO:: Fix this offset.
  &:target:before {
    content: "";
    display: block;
    height: 100px;
    margin: -100px 0 0;
  }
`;

const ACCORDION_ITEM_HEIGHT = 200;

const CourseList = ({ course }) => {
  const { courses, courseEnhancements } = course;
  const { isMobile } = useWindowDimensions();
  const expandedRef = useRef();
  return (
    <div ref={expandedRef}>
      <Box marginVertical={{ xs: 3, lg: 6 }}>
        <StyledHeading id="course-content" component="h3" size={2}>
          Course Content
        </StyledHeading>
        <StyledHeading component="h5">
          Click on the modules below to find out what you&apos;ll learn at each stage of the course.
        </StyledHeading>
        <ExpanderGroup
          onExpanderToggled={(e) => {
            // e = the index of the expander. We know the index * height(expandedSection) will be the extra offset it needs.
            // hardCoded to 200 for the moment.
            scrollToRef(expandedRef, e * 200);
          }}
        >
          {Array.isArray(courses) && courses.length
            ? courses.map(
                ({ modules, subTitle, title, timeToComplete, moduleId, image }, index) => (
                  <ExpandedSection
                    title={title}
                    subTitle={subTitle}
                    key={index}
                    timeToComplete={timeToComplete}
                    moduleId={moduleId}
                    isMobile={isMobile}
                    image={image}
                  >
                    <CourseItem isMobile={isMobile} modules={modules} title={title} />
                  </ExpandedSection>
                )
              )
            : null}
        </ExpanderGroup>
        {Array.isArray(courseEnhancements) && (
          <CourseEnhancements enhancements={courseEnhancements} />
        )}
      </Box>
    </div>
  );
};

CourseList.propTypes = {
  course: PropTypes.shape({
    courses: PropTypes.array,
    courseEnhancements: PropTypes.array,
  }),
};

export default CourseList;
